module.exports = function (e) {
  var t = {};

  function n(o) {
    if (t[o]) return t[o].exports;
    var r = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, o) {
    n.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: o
    });
  }, n.r = function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 2);
}([function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      u = n(1),
      i = a(u),
      c = a(n(0));

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, u.PureComponent), r(t, [{
      key: "selectTextFromElement",
      value: function value() {
        if (window.getSelection && document.createRange) {
          var e = window.getSelection(),
              t = document.createRange();
          t.selectNodeContents(this.urlSpan), e.removeAllRanges(), e.addRange(t);
        } else if (document.selection && document.body.createTextRange) {
          var n = document.body.createTextRange();
          n.moveToElementText(this.urlSpan), n.select();
        }
      }
    }, {
      key: "copy",
      value: function value() {
        this.selectTextFromElement();
        var e = void 0,
            t = void 0;

        try {
          document.execCommand("copy"), e = !0;
        } catch (n) {
          e = !1, t = n;
        }

        this.props.onCopy && this.props.onCopy({
          success: e,
          error: t
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.textToBeCopied,
            r = (t.onCopy, t.children),
            u = function (e, t) {
          var n = {};

          for (var o in e) {
            t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
          }

          return n;
        }(t, ["textToBeCopied", "onCopy", "children"]),
            c = i.default.Children.only(r),
            a = this.copy.bind(this),
            l = i.default.cloneElement(c, o({}, c.props, {
          onClick: a
        }));

        return i.default.createElement(i.default.Fragment, null, i.default.createElement("span", o({}, u, {
          ref: function ref(t) {
            e.urlSpan = t;
          }
        }), n), l);
      }
    }]), t;
  }();

  l.propTypes = {
    textToBeCopied: c.default.string.isRequired,
    children: c.default.element.isRequired,
    onCopy: c.default.func
  }, l.defaultProps = {
    onCopy: void 0
  }, t.default = l;
}]);